import { type yup } from '@framework/validation';
import { CitizenRegisterSchema } from './CitizenRegisterSchema';

export const CitizenEditSchema = CitizenRegisterSchema.omit([
  'privacyAcceptance',
  'nationality',
  'confirmPassword',
  'password',
  'email',
]);

export type ICitizenEditDto = yup.InferType<typeof CitizenEditSchema>;
